
import { jitsiLocalStorage } from '@jitsi/js-utils';
import type { Dispatch } from 'redux';


import getRoomName from '../config/getRoomName';
import { configureInitialDevices } from '../devices/actions';
import { getBackendSafeRoomName } from '../util';

export {
    connectionDisconnected,
    connectionEstablished,
    connectionFailed,
    setLocationURL
} from './actions.native';
import { _connectInternal } from './actions.any';
import logger from './logger';

declare var APP: Object;


/**
 * Opens new connection.
 *
 * @returns {Promise<MHConnection>}
 */
export function connect() {
    return (dispatch: Dispatch<any>, getState: Function) => {
        // The room normally comes from the store, but the conference page can mount while the store has none - it
        // is cleared when a conference ends, and the page can be started again from there. The URL still names the
        // room then, which is what conference.js itself falls back to. Without one there is nothing to join:
        // creating a conference without a name throws ('Invalid conference name ... No room name passed!').
        const room = getBackendSafeRoomName(getState()['features/base/conference'].room) || getRoomName();

        if (!room) {
            return Promise.resolve();
        }

        // XXX For web based version we use conference initialization logic
        // from the old app (at the moment of writing).
        return dispatch(configureInitialDevices()).then(
            () => APP.conference.init({
                roomName: room
            }).catch(error => {
                APP.API.notifyConferenceLeft(APP.conference.roomName);
                logger.error('Conference initialization failed:', error);

                // Re-throw the error to ensure it's properly handled upstream
                throw error;
            }))
.catch(error => {
    logger.error('Connection failed:', error);


    // Handle the error gracefully instead of letting it become unhandled
    return Promise.reject(error);
});
    };
}

/**
 * Closes connection.
 *
 * @param {boolean} [requestFeedback] - Whether or not to attempt showing a
 * request for call feedback.
 * @returns {Function}
 */
export function disconnect(requestFeedback: boolean = false) {
    // XXX For web based version we use conference hanging up logic from the old
    // app.
    return () => APP.conference.hangup(requestFeedback);
}


/**
 * Opens new connection.
 *
 * @param {string} [id] - The XMPP user's ID (e.g. {@code user@server.com}).
 * @param {string} [password] - The XMPP user's password.
 * @returns {Function}
 */
export function connectVisitor(id, password) {
    return dispatch => {


        // used by jibri
        const usernameOverride = jitsiLocalStorage.getItem('xmpp_username_override');
        const passwordOverride = jitsiLocalStorage.getItem('xmpp_password_override');

        let resolvedId = id;
        let resolvedPassword = password;

        if (usernameOverride && usernameOverride.length > 0) {
            resolvedId = usernameOverride;
        }
        if (passwordOverride && passwordOverride.length > 0) {
            resolvedPassword = passwordOverride;
        }

        // console.log('connectVisitor');

        return dispatch(_connectInternal(resolvedId, resolvedPassword));
    };
}
